import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import { AutoComplete, RetrieveById } from '../../utils/AddressComplete';
import find from 'array.prototype.find';
import debounce from 'debounce';
import { throttle } from 'throttle-debounce';

find.shim();

class AutoCompleteAddress extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "",
      isLoading: false,
      suggestions: [],
      invalid: this.props.invalid
    }
    this.error = false

    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    this.loadSuggestionsDebounced = debounce(this.loadSuggestions, 500);
    this.loadSuggestionsThrottled = throttle(500, this.loadSuggestions);
  }
  componentDidUpdate(prevProps) {
    if(prevProps.invalid !== this.props.invalid) {      
      this.setState({
        invalid: this.props.invalid
      });
    }
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  loadSuggestions(value) {
    this.setState({
      isLoading: true
    });    
    AutoComplete(value).then(results => {
      if(this.mounted && results) {
        if(results.Items.length === 1 && results.Items[0].Error) {
          // If there's an error with the response, switch to manual entry mode.      
          if(!this.error) {
            // Set error to true to prevent manual entry toggling. 
            this.error = true;
            this.props.toggleManualEntry({}, true);
          }
        }
        else {
          this.setState({
            isLoading: false,
            suggestions: results.Items
          });
        }
      }
    });
  };
  onSuggestionsFetchRequested({value}) {
    if (value.length < 5 || value.endsWith(' ')) {
      this.loadSuggestionsThrottled(value);
    }
    else {
      this.loadSuggestionsDebounced(value);
    }
  }
  onSuggestionsClearRequested() {
    this.setState({
      suggestions: []
    });
  }
  onChange = (event,test) => {    
    // Update the address1 field at the same time 
    this.props.handleChange({target: {name: "address1", value: test.newValue}});    
    this.setState({
      value: test.newValue,
      invalid: false
    });
  };
  onSuggestionSelected = (event, suggestion) => { 
    event.preventDefault();
    // If it's not retrievable, make a call to AutoCompleteFind
    if(suggestion.suggestion.Next === "Find") {
      this.setState({
        isLoading: true
      });
      AutoComplete(this.state.value, suggestion.suggestion.Id).then(results => {
        if(this.mounted && results) {
          this.setState({
            isLoading: false,
            suggestions: results.Items
          });
        }
      });
    } 
    // If it is retrievable, make a call to RetrieveById 
    else if(suggestion.suggestion.Next === "Retrieve") {
      this.setState({
        isLoading: true
      });
      RetrieveById(suggestion.suggestion.Id).then(result => {
        if(this.mounted && result) {
          this.setState({
            isLoading: false,
          });
          // Retrieve address fields from response
          let addressFields = {
            address1: result.Items.find((item) => item.FieldName === "Line1" && item.FieldGroup === "Common").FormattedValue,
            address2: result.Items.find((item) => item.FieldName === "Line2" && item.FieldGroup === "Common").FormattedValue,
            city: result.Items.find((item) => item.FieldName === "City" && item.FieldGroup === "Common").FormattedValue,
            province: result.Items.find((item) => item.FieldName === "ProvinceCode" && item.FieldGroup === "Common").FormattedValue,
            postalCode: result.Items.find((item) => item.FieldName === "PostalCode" && item.FieldGroup === "Common").FormattedValue
          }
          // Call onChange event in parent component
          this.props.onChange(addressFields);
          this.props.toggleManualEntry();
        }
      });
    }
  }
  renderSuggestion = suggestion => {
    let value = "";
    let description = "";
    let moreResults;

    value = suggestion.Text;
    description = suggestion.Description;

    let hightlights = suggestion.Highlight.split(",");

    let offset = 0
    let valueLength = value.length;
    hightlights.forEach(hightlight => {
      let index = hightlight.split("-");
      if(index.length === 2) {
        let index1 = parseInt(index[0], 10) + offset;
        let index2 = parseInt(index[1], 10) + offset;
        value = `${value.slice(0, index1)}<b>${value.slice(index1, index2)}</b>${value.slice(index2, valueLength + offset)}`;
        offset += 7; // offset to take into account addition of bold markup
      }
    })
    
    if(suggestion.Next === "Find") {
      moreResults = <div className="more-results"></div>
    }
    return (
      <div>
        <span dangerouslySetInnerHTML={{__html: value}} /><div className="description">{description}</div>{moreResults}
      </div>
    );
  }
  getSuggestionValue = suggestion => {   
    let value = "";
  
    if('Suggestion' in suggestion) {
      value = suggestion.Suggestion;
    }
    else {
      value = suggestion.Text;
    }
    return(value);
  }
  render() {
    const { value, suggestions } = this.state;

    const inputProps = {
      placeholder: '',
      value,
      onChange: this.onChange,
      autoFocus: this.props.autoFocus,
      autoComplete: "address",
      autoCapitalize: "words",
      autoCorrect: "off"
    };

    return (
      <div className={this.state.invalid ? "is-invalid" : ""}>
        <Autosuggest 
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          onSuggestionSelected={this.onSuggestionSelected}
          inputProps={inputProps}
          highlightFirstSuggestion={true}
          id="homeAddress"
          />
      </div>
    );
  }
}

AutoCompleteAddress.defaultProps= {  
  onChange:() => {},
  toggleManualEntry: () => {},
  invalid: false,
  autoFocus: false
};

AutoCompleteAddress.propTypes = {
  onChange: PropTypes.func,
  toggleManualEntry: PropTypes.func,
  invalid: PropTypes.bool,
  autoFocus: PropTypes.bool
};

export default AutoCompleteAddress;


// WEBPACK FOOTER //
// ./src/components/Address/AutoCompleteAddress.js